import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Truck, Plus, Trash2 } from "lucide-react";

export default function OfficineMobiliPage() {
  const [items, setItems] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ nome: "", targa: "", assegnato_a: "" });

  const load = async () => { const { data } = await api.get("/officine-mobili"); setItems(data); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/officine-mobili", form); toast.success("Furgone aggiunto"); setForm({nome:"",targa:"",assegnato_a:""}); setCreating(false); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare? Verranno cancellate anche le giacenze interne.")) return;
    await api.delete(`/officine-mobili/${id}`); load();
  };

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Magazzini Mobili</div>
          <h1 className="font-display text-4xl font-black uppercase tracking-tight">Officine Mobili</h1>
        </div>
        <button onClick={()=>setCreating(!creating)} className="gm-btn-primary h-11 px-5 rounded-sm flex items-center gap-2" data-testid="officine-new-button">
          <Plus size={16} /> Nuovo furgone
        </button>
      </div>

      {creating && (
        <form onSubmit={submit} className="gm-card p-5 mb-5 grid grid-cols-1 md:grid-cols-4 gap-3">
          <input required placeholder="Nome (es. Furgone 03)" value={form.nome} onChange={e=>setForm(s=>({...s,nome:e.target.value}))} className="gm-input" data-testid="officina-nome" />
          <input placeholder="Targa" value={form.targa} onChange={e=>setForm(s=>({...s,targa:e.target.value}))} className="gm-input font-mono-data" />
          <input placeholder="Assegnato a" value={form.assegnato_a} onChange={e=>setForm(s=>({...s,assegnato_a:e.target.value}))} className="gm-input" />
          <button type="submit" className="gm-btn-primary h-12 rounded-sm" data-testid="officina-submit">Crea</button>
        </form>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.length === 0 && <div className="text-zinc-500">Nessuna officina mobile configurata.</div>}
        {items.map(o => (
          <div key={o.id} className="gm-card p-4 flex items-center gap-3" data-testid="officina-card">
            <div className="h-12 w-12 bg-[#4CAF50]/10 border border-[#4CAF50]/30 flex items-center justify-center">
              <Truck className="text-[#4CAF50]" size={22} />
            </div>
            <div className="flex-1">
              <div className="font-display text-lg font-bold uppercase">{o.nome}</div>
              <div className="text-xs text-zinc-500 font-mono-data">{o.targa || "—"}{o.assegnato_a?` • ${o.assegnato_a}`:""}</div>
            </div>
            <button onClick={()=>del(o.id)} className="text-[#FF3B30] hover:bg-[#FF3B30]/10 p-2"><Trash2 size={16}/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
